// Copyright (c) 2022 by Move Closer

import { ModalRegistry } from '@movecloser/front-core'
import { AsyncComponent, VueConstructor } from 'vue'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Filip Rurak <filip.rurak@movecloser.pl> (edited)
 */
export enum Drawers {
  AddedToCard = 'addedToCard',
  Cart = 'cart'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum Modals {
  AddedToCartModal = 'addedToCartModal',
  DHLModal = 'dhlModal',
  InPostModal = 'inpostModal',
  BlikProcessingModal = 'blikProcessingModal'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Filip Rurak <filip.rurak@movecloser.pl> (edited)
 */
export const drawersRegistry = {
  [Drawers.AddedToCard]: () => import(/* webpackChunkName: "modal/AddedToCartDrawer" */ '../organisms/AddedToCartDrawer/AddedToCartDrawer.vue'),
  [Drawers.Cart]: () => import(/* webpackChunkName: "modal/CartDrawer" */ '../organisms/CartDrawer/CartDrawer.vue')
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const modalsRegistry: ModalRegistry<AsyncComponent> = {
  [Modals.AddedToCartModal]: () => import(/* webpackChunkName: "modal/AddedToCartModal" */ '../organisms/AddedToCartModal/AddedToCartModal.vue'),
  [Modals.InPostModal]: () => import(/* webpackChunkName: "modal/InPostModal" */ '../organisms/InPostModal/InPostModal.vue'),
  [Modals.DHLModal]: () => import(/* webpackChunkName: "modal/DHLModal" */ '../organisms/DHLModal/DHLModal.vue'),
  [Modals.BlikProcessingModal]: () => import(/* webpackChunkName: "modal/BlikProcessingModal" */ '../organisms/BlikProcessingModal/BlikProcessingModal.vue')
}
